var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['caption', _vm.type ? _vm.type : '',{
      'is-plain': _vm.plain,
      'is-round': _vm.round
    }]},[(_vm.$slots.default)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }